import type { ClefQuestion } from '@/data/clefQuiz';

/**
 * Perguntas de apoio para a aula "Introdução à clave de fá".
 * A clave de fá organiza a leitura das notas graves — a mão esquerda no teclado.
 */
export const BASS_CLEF_QUESTIONS: ClefQuestion[] = [
  {
    id: 'bass-name',
    glyph: '𝄢',
    glyphHint: 'Clave de fá',
    question: 'Qual é o nome desta clave?',
    options: ['Clave de fá', 'Clave de sol', 'Clave de dó'],
    answerIndex: 0,
    explanation:
      'É a clave de fá. Ela é usada para as notas graves — no teclado, a região tocada pela mão esquerda.',
  },
  {
    id: 'bass-function',
    glyph: '𝄢',
    glyphHint: 'Clave de fá',
    question: 'Para que serve a clave de fá?',
    options: [
      'Orientar a leitura das notas graves na pauta',
      'Marcar a duração das notas',
      'Indicar a velocidade da música',
      'Marcar as pausas',
    ],
    answerIndex: 0,
    explanation:
      'Assim como a clave de sol orienta as notas agudas, a clave de fá posiciona as notas graves em cada linha e espaço.',
  },
  {
    id: 'bass-line',
    glyph: '𝄢',
    glyphHint: 'Clave de fá',
    question: 'Em qual linha a clave de fá coloca a nota Fá?',
    options: ['Na quarta linha', 'Na primeira linha', 'Na segunda linha', 'Na quinta linha'],
    answerIndex: 0,
    explanation:
      'Os dois pontos da clave de fá abraçam a quarta linha de baixo para cima, e é ali que fica o Fá (Fá3).',
  },
  {
    id: 'bass-middle-c',
    glyph: '𝄢',
    glyphHint: 'Clave de fá',
    question: 'Onde fica o Dó central na clave de fá?',
    options: [
      'Na linha suplementar acima da pauta',
      'Na linha suplementar abaixo da pauta',
      'Na segunda linha',
      'No terceiro espaço',
    ],
    answerIndex: 0,
    explanation:
      'O Dó central (Dó4) fica na primeira linha suplementar acima da pauta na clave de fá — o ponto de encontro entre as duas mãos.',
  },
];